/**
 * Created by vladimir on 12.10.17
 */

const EditorLevelView = cc.Node.extend({
    ctor: function () {
        this._super();

        // eslint-disable-next-line no-restricted-syntax
        const title = cleverapps.UI.generateTTFText("LevelNo:", cleverapps.styles.FONTS.EDITOR_TEXT);

        this.levelNo = new IncDecBlock({
            range: [1, levels.User.CalcEpisodesAmount(true) * AdminEpisode.LEVELS_PER_EPISODE],
            onChange: this.gotoNewLevel.bind(this),
            icons: "leftright",
            value: LevelManager.getInstance().level.getHumanReadableNumber()
        });

        cleverapps.UI.wrap(this.levelNo);

        const content = new cleverapps.Layout([title, this.levelNo], {
            direction: cleverapps.UI.HORIZONTAL,
            margin: cleverapps.styles.EditorLevelView.margin
        });
        this.addChild(content);

        this.onResize();
    },
    
    gotoNewLevel: function (levelNo) {
        levelNo--;
        let episodeNo = Math.floor(levelNo / AdminEpisode.LEVELS_PER_EPISODE);
        if (typeof LevelManager.getInstance().level.episodeNo === "string") {
            episodeNo = LevelManager.getInstance().level.episodeNo;

            const adminEpisode = cleverapps.administrator.adminEpisodes.getEpisode(episodeNo);
            const content = adminEpisode.getEpisodeLevels();
            if (levelNo >= content.length) {
                return;
            }
        }

        LevelManager.getInstance().setVersion(undefined);
        LevelManager.getInstance().setLevel({
            episodeNo,
            levelNo: levelNo % AdminEpisode.LEVELS_PER_EPISODE
        });

        cleverapps.setUrlHash({
            episode: episodeNo,
            level: levelNo % AdminEpisode.LEVELS_PER_EPISODE
        });

        LevelManager.getInstance().editLevel();
    },

    onResize: function () {
        this.setAlignment(cleverapps.styles.EditorLevelView);
    }
});

cleverapps.styles.EditorLevelView = {
    x: { align: "center" },
    y: { align: "top", dy: -40 },
    margin: 10
};